import { useVariant } from "@~/contexts/VariantContext/VariantContext";
import styles from "./StaticImage.module.scss";
import { CardComponentProps } from "@~/types/types";
import { PDPLink } from "../__shared__/PDPLink/PDPLink";
import { isM2MFabricProduct } from "../__shared__/PDPLink/components/M2MProductSelector/utils";
import { Image } from "../__shared__/Image/Image";

export const StaticImage = ({
  index,
  product,
}: Pick<CardComponentProps, "index" | "product">) => {
  const { variant } = useVariant();
  const isM2MProduct = isM2MFabricProduct(product);

  const baseImgUrl = variant?.images.primary.split("?")[0] || "";

  if (!baseImgUrl) {
    return null;
  }

  const imageElement = (
    <Image
      url={baseImgUrl}
      title={product.title}
      colour={variant?.colour?.colour || ""}
      index={index}
    />
  );

  const containerClass = isM2MProduct
    ? styles.buttonContainer
    : styles.container;

  return (
    <PDPLink
      product={product}
      className={containerClass}
      componentName="StaticImage"
      tabIndex={-1}
    >
      {imageElement}
    </PDPLink>
  );
};
